import React, { PureComponent } from "react";

import BrandName from "./Fields/BrandName";
import ModelName from "./Fields/ModelName";
import TypeName from "./Fields/TypeName";
import ProductionYear from "./Fields/ProductionYear";
import CategoryName from "./Fields/CategoryName";
import PassengerCapacity from "./Fields/PassengerCapacity";
import VehicleLicenseInfo from "./Fields/VehilcleLicenseInfo";

// import VehiclePhoto from './Fields/VehiclePhoto';

// import { UPLOAD_VEHICLE_PHOTOS } from '../../../api/constants';

class Main extends PureComponent {
  componentDidMount() {
    if (this.props.fields && this.props.fields["brandName"]) {
      this.props.getModelsByBrand(this.props.fields["brandName"]);
    }
  }

  render() {
    const { setFields } = this.props.form;
    const { fields, disabled, getModelsByBrand } = this.props; // , vehicleId
    const { form } = this.props;

    // const isAvtocodSearch = form.getFieldValue('avtocodSearch');
    const brandId = form.getFieldValue("brand");

    return (
      <div className="oneSectionArea" style={{paddingBottom: 24}}>
        {/*<div className="upload-element">
          <VehiclePhoto
            form={form}
            disabled={disabled}
            name={`photo1`}
            data={{ vehicle_id: vehicleId, photo_number: 1 }}
            action={vehicleId && vehicleId > 0 ? UPLOAD_VEHICLE_PHOTOS : null}
          />
        </div>*/}
        <div className="wrapper1">
          <BrandName
            form={form}
            disabled={disabled}
            onChange={id => {
              getModelsByBrand(id);
              setFields({
                modelName: { value: fields && fields["brandName"] }
              });
            }}
          />
          <ModelName
            form={form}
            disabled={disabled}
            getModelsByBrand={getModelsByBrand}
            brandId={brandId}
          />
          <TypeName form={form} disabled={disabled} />
          <ProductionYear form={form} disabled={disabled} />
          <CategoryName form={form} disabled={disabled} />
          <PassengerCapacity form={form} disabled={disabled} />
        </div>
        <div className="aHeight-3" style={{height: 32}}></div>
        <div className="wrapper1">
          <VehicleLicenseInfo form={form} disabled={disabled} />
        </div>
      </div>
    );
  }
}

export default Main;
